import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {UNASSIGNED_TASK_TEXT} from 'processes/ProcessConstants';
import TaskStatusIcon from 'processes/status/TaskStatusIcon';
import Avatar, {NO_AVATAR_URL} from 'ui-library/avatar/Avatar';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import AvatarIcon from 'ui-library/icons/AvatarIcon';
import PartyList from 'ui-library/PartyList';

import {ProcessTaskListingGraphQL} from '../../../graphql-fragments/processes/__generated/ProcessTaskListingGraphQL';

type ProcessTaskResponsibleParty = ProcessTaskListingGraphQL['responsibleParties'][number];
type ProcessTaskStatus = ProcessTaskListingGraphQL['status'];
type ProcessTaskAssignee = NonNullable<ProcessTaskListingGraphQL['assignee']>;

export function ProcessTaskStatusDisplay(props: {status: ProcessTaskStatus}): JSX.Element {
  return (
    <div className={css(styles.cellContainer)}>
      <TaskStatusIcon type={props.status.statusType} />
      <span className={css(styles.statusDisplayText)}>{props.status.displayName}</span>
    </div>
  );
}

export function ProcessTaskAssigneeDisplay(props: {assignee: ProcessTaskAssignee | null}): JSX.Element {
  return (
    <div className={css(styles.cellContainer)}>
      {props.assignee != null ? (
        <Avatar entity={props.assignee} size={AvatarSize.XSMALL} />
      ) : (
        <AvatarIcon avatarUrl={NO_AVATAR_URL} size={AvatarSize.XSMALL} />
      )}
      <span className={css(styles.assigneeDisplayText)}>{props.assignee?.name ?? UNASSIGNED_TASK_TEXT}</span>
    </div>
  );
}

export default function ProcessResponsibleParties(props: {
  responsibleParties: Array<ProcessTaskResponsibleParty>;
}): JSX.Element {
  if (props.responsibleParties.length === 0) {
    return <span className="u-faded">No value</span>;
  } else {
    return <PartyList parties={props.responsibleParties} maxParties={1} useAvatar={true} />;
  }
}

const styles = StyleSheet.create({
  cellContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  assigneeDisplayText: {
    paddingLeft: '8px',
  },
  statusDisplayText: {
    paddingLeft: '3px',
  },
});
